<template>
  <div class="w-full" v-if="choices">
    <div class="flex items-center justify-between w-full">
      <div
        v-for="choice in choices"
        :key="choice.code"
        class="flex-1 border border-blue-400 text-center cursor-pointer py-2"
        :class="{ 'bg-blue-400 text-white':choice.active }"
        @click="setValue(choice.code)"
      >{{ choice.description }}</div>
    </div>
    <input type="hidden" :name="name" :value="value" />
  </div>
</template>

<script>
export default {
  name: "RadioInput",
  props: ["value", "options", "name", "default"],
  data() {
    return {
      choices: []
    };
  },
  methods: {
    setValue(code) {
      this.$emit("input", code);

      for (let choice of this.choices) {
        choice.active = choice.code == code ? true : false;
      }
    },
    setOptions() {
      return new Promise(resolve => {
        if (this.options) {
          for (let option of this.options) {
            option.active = false;
            this.choices.push(option);
          }
          resolve("resolved");
        }
      });
    },
    setDefault() {
      if (this.default) {
        this.setValue(this.default);
      }
    },
    async prepareComponent() {
      await this.setOptions();
      this.setDefault();
    }
  },
  created() {
    this.prepareComponent();
  },
  watch: {
    value() {
      this.setValue(this.value)
    }
  }
};
</script>

<style lang="scss" scoped>
</style>